// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__1EsHu","select":"Select_select__Q1gdw","compact":"Select_compact__3NNzv","hasContent":"Select_hasContent__8DDHX"};